<template>
  <div class="news-details">
    <banner :img="require('@/assets/img/bgtop.jpg')" :title="newsDetail.Title || '新闻详情'" :height="150" />
    <div class="news-details-content" v-loading="loading">
      <div class="content-wrapper">
        <div class="news-header">
          <h1 class="news-title">{{ newsDetail.Title }}</h1>
          <div class="news-meta">
            <span class="news-time">
              <i class="el-icon-time"></i> {{ newsDetail.CreateTime }}
            </span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="news-body">
          <div class="news-image-wrapper" v-if="newsDetail.Img">
            <img :src="newsDetail.Img" :alt="newsDetail.Title" class="news-image" @error="onImageError" />
          </div>
          <div class="news-text" v-html="newsDetail.Content"></div>
        </div>

        <el-divider></el-divider>

        <div class="news-footer">
          <router-link to="/news" class="back-link">
            <i class="el-icon-arrow-left"></i> 返回云平台
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";

export default {
  name: "NewsDetails",
  components: {
    Banner
  },
  data() {
    return {
      loading: true,
      newsDetail: {
        Title: "",
        Content: "",
        Img: "",
        CreateTime: ""
      }
    };
  },
  created() {
    this.loadNewsDetail();
  },
  methods: {
    loadNewsDetail() {
      this.loading = true;
      const newsId = this.$route.params.id;

      // 静态新闻数据
      const staticNews = {
        "0": {
          Title: "整机装车测试",
          Content: "前往安徽宣城参加整机装车测试，对S628系列智能BMS系统进行实地装车验证。测试内容包括电池管理系统与叉车的兼容性测试、充放电性能测试、数据传输稳定性测试等。经过为期一周的测试，系统各项指标均达到设计要求，获得了客户的高度认可。",
          Img: "https://forklift.ehuatech.com.cn/forklift-test/2026/02/12/1770886034561_67_active1.png",
          CreateTime: "2025-02-10 09:15:00"
        },
        "1": {
          Title: "批量测试",
          Content: "完成S618系列产品的批量生产测试，共计测试200台设备。测试涵盖功能测试、老化测试、EMC测试等多个环节。所有产品一次性通过率超过98%，标志着该系列产品已具备大规模量产条件。",
          Img: "https://forklift.ehuatech.com.cn/forklift-test/2026/02/12/1770886048869_279_active2.png",
          CreateTime: "2025-02-13 12:00:00"
        },
        "2": {
          Title: "测试厂房高低温测试",
          Content: "在专业测试厂房进行高低温环境测试，测试温度范围覆盖-40°C至85°C。通过严苛的环境适应性测试，验证了S608系列产品的可靠性和稳定性，确保产品能够在各种极端环境下正常工作。",
          Img: "https://forklift.ehuatech.com.cn/forklift-test/2026/02/12/1770886067235_301_active3.png",
          CreateTime: "2025-02-17 12:00:00"
        }
      };

      const news = staticNews[newsId];
      if (news) {
        this.newsDetail = news;
      } else {
        this.newsDetail = {
          Title: "新闻详情",
          Content: "该新闻内容暂未录入系统，敬请期待。",
          Img: "",
          CreateTime: ""
        };
      }

      this.loading = false;
    },
    onImageError(event) {
      event.target.style.display = "none";
    }
  }
};
</script>

<style lang="scss" scoped>
.news-details {
  width: 100%;
  min-height: 100vh;
  background-color: #f8f9fa;

  &-content {
    max-width: 900px;
    margin: 0 auto;
    padding: 40px 20px;

    .content-wrapper {
      background: #fff;
      border-radius: 12px;
      padding: 40px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    .news-header {
      text-align: center;

      .news-title {
        font-size: 28px;
        color: #333;
        margin-bottom: 15px;
        font-weight: 600;
        line-height: 1.4;
      }

      .news-meta {
        color: #999;
        font-size: 14px;

        i {
          margin-right: 5px;
        }
      }
    }

    .news-body {
      padding: 20px 0;

      .news-image-wrapper {
        width: 100%;
        margin-bottom: 30px;
        border-radius: 8px;
        overflow: hidden;

        .news-image {
          width: 100%;
          max-height: 500px;
          object-fit: cover;
          display: block;
        }
      }

      .news-text {
        font-size: 16px;
        line-height: 1.8;
        color: #444;
        text-align: justify;

        ::v-deep p {
          margin-bottom: 15px;
        }
      }
    }

    .news-footer {
      padding-top: 10px;

      .back-link {
        display: inline-flex;
        align-items: center;
        color: #1a75bb;
        text-decoration: none;
        font-size: 15px;
        transition: all 0.3s ease;

        i {
          margin-right: 5px;
        }

        &:hover {
          color: #14679f;
          transform: translateX(-3px);
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .news-details-content {
    padding: 20px 15px !important;

    .content-wrapper {
      padding: 25px 20px !important;
    }

    .news-title {
      font-size: 22px !important;
    }

    .news-text {
      font-size: 15px !important;
    }
  }
}
</style>
